/* Jane Lushka 4.2 homepage "As seen on you" (sections/jl-home-ugc.liquid).
   + hotspots: a tap opens that piece's card (button aria-expanded / aria-controls, the card is a hidden sibling).
   One card open at a time on the page; a tap outside, Esc (focus back on the +) or scrolling the row closes it.
   Arrows (shown from 1024px by CSS) scroll the row by its visible width and hide at either end.
   Placing helper (theme editor, or any page opened with ?ugc-place): a click on a look's photo, away from a +, shows
   "across X · down Y" there, the numbers to type into that piece's + fields of the look (Content > Metaobjects).
   Video looks: the muted video loads on its first play, plays only while at least half of it is on screen, and pauses
   while one of its cards is open; the button top right pauses and plays it (a pause by hand sticks). With reduced
   motion or data saver on, nothing plays until that button is used. data-start / data-end (seconds) loop only that part.
   defer; re-runs on shopify:section:load so the theme editor preview stays live. */
(function () {
  'use strict';

  if (window.JLHomeUgc) return;
  window.JLHomeUgc = true;

  var open = null;
  var still = (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ||
    !!(navigator.connection && navigator.connection.saveData);

  function videoOf(el) {
    var item = el && el.closest && el.closest('.jl-ugc__item');
    return item ? item.querySelector('[data-jl-ugc-video]') : null;
  }

  function vplay(v) {
    if (!v) return;
    var s = v.__jl;
    if (!s || !s.auto || !s.seen || s.held) return;
    if (!v.getAttribute('src')) v.setAttribute('src', v.getAttribute('data-src'));
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  function vsync(v) {
    var btn = v.parentNode.querySelector('[data-jl-ugc-play]');
    if (!btn) return;
    var paused = v.paused;
    btn.classList.toggle('is-paused', paused);
    btn.setAttribute('aria-label', btn.getAttribute(paused ? 'data-play' : 'data-pause'));
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      var v = entries[i].target;
      v.__jl.seen = entries[i].isIntersecting;
      if (v.__jl.seen) vplay(v); else v.pause();
    }
  }, { threshold: 0.5 }) : null;

  function videos(root) {
    var list = root.querySelectorAll('[data-jl-ugc-video]');
    for (var i = 0; i < list.length; i++) {
      var v = list[i];
      if (v.__jl) continue;
      v.__jl = { auto: !still, seen: !io, held: false };
      v.muted = true;
      var a = parseFloat(v.getAttribute('data-start')) || 0;
      var z = parseFloat(v.getAttribute('data-end')) || 0;
      if (a > 0 || z > 0) {
        v.__jl.a = a;
        v.__jl.z = z > a ? z : 0;
        v.addEventListener('loadedmetadata', function () {
          if (this.__jl.a && this.currentTime < this.__jl.a) this.currentTime = this.__jl.a;
        });
        v.addEventListener('timeupdate', function () {
          var j = this.__jl;
          if ((j.z && this.currentTime >= j.z) || this.currentTime < j.a - 0.3) this.currentTime = j.a;
        });
        v.addEventListener('ended', function () {
          this.currentTime = this.__jl.a;
        });
      }
      v.addEventListener('play', function () { vsync(this); });
      v.addEventListener('pause', function () { vsync(this); });
      var btn = v.parentNode.querySelector('[data-jl-ugc-play]');
      if (btn) btn.hidden = false;
      if (io) io.observe(v); else vplay(v);
    }
  }

  function close(focusBack) {
    if (!open) return;
    var dot = open;
    var pop = document.getElementById(dot.getAttribute('aria-controls'));
    dot.setAttribute('aria-expanded', 'false');
    if (pop) pop.hidden = true;
    open = null;
    var v = videoOf(dot);
    if (v && v.__jl) {
      v.__jl.held = false;
      vplay(v);
    }
    if (focusBack) dot.focus();
  }

  function toggle(dot) {
    var was = open === dot;
    close(false);
    if (was) return;
    var pop = document.getElementById(dot.getAttribute('aria-controls'));
    if (!pop) return;
    pop.hidden = false;
    dot.setAttribute('aria-expanded', 'true');
    open = dot;
    var v = videoOf(dot);
    if (v && v.__jl) {
      v.__jl.held = true;
      v.pause();
    }
  }

  function arrows(root) {
    var track = root.querySelector('[data-jl-ugc-track]');
    var prev = root.querySelector('[data-jl-ugc-prev]');
    var next = root.querySelector('[data-jl-ugc-next]');
    if (!track || !prev || !next) return;

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var x = Math.abs(track.scrollLeft);
      prev.hidden = max <= 2 || x <= 2;
      next.hidden = max <= 2 || x >= max - 2;
    }

    function step(dir) {
      var item = track.querySelector('.jl-ugc__item');
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var w = item ? item.getBoundingClientRect().width + gap : track.clientWidth;
      var n = Math.max(1, Math.floor((track.clientWidth + gap) / w) - 1);
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollBy({ left: dir * w * n, behavior: reduce ? 'auto' : 'smooth' });
    }

    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', function () {
      if (open && track.contains(open)) close(false);
      update();
    }, { passive: true });
    window.addEventListener('resize', update);
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
    update();
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-jl-ugc]');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].__jlUgc) continue;
      roots[i].__jlUgc = true;
      arrows(roots[i]);
      videos(roots[i]);
    }
  }

  document.addEventListener('click', function (e) {
    var pb = e.target.closest && e.target.closest('[data-jl-ugc-play]');
    if (pb) {
      e.preventDefault();
      var pv = videoOf(pb);
      if (!pv || !pv.__jl) return;
      if (pv.paused) {
        pv.__jl.auto = true;
        pv.__jl.seen = true;
        pv.__jl.held = false;
        if (open && videoOf(open) === pv) close(false);
        vplay(pv);
      } else {
        pv.__jl.auto = false;
        pv.pause();
      }
      return;
    }
    var dot = e.target.closest && e.target.closest('[data-jl-ugc-dot]');
    if (dot) {
      e.preventDefault();
      toggle(dot);
      return;
    }
    if (open && !(e.target.closest && e.target.closest('[data-jl-ugc-pop]'))) close(false);
  });

  var placing = (window.Shopify && window.Shopify.designMode) || /[?&]ugc-place(=|&|$)/.test(location.search);
  if (placing) {
    document.addEventListener('click', function (e) {
      var media = e.target.closest && e.target.closest('.jl-ugc__media');
      if (!media || e.target.closest('[data-jl-ugc-dot]') || e.target.closest('[data-jl-ugc-pop]') || e.target.closest('[data-jl-ugc-play]')) return;
      var r = media.getBoundingClientRect();
      var x = Math.max(0, Math.min(100, Math.round((e.clientX - r.left) / r.width * 100)));
      var y = Math.max(0, Math.min(100, Math.round((e.clientY - r.top) / r.height * 100)));
      var tip = media.querySelector('.jl-ugc__place');
      if (!tip) {
        tip = document.createElement('span');
        tip.className = 'jl-ugc__place';
        tip.setAttribute('role', 'status');
        media.appendChild(tip);
      }
      tip.style.setProperty('--x', x + '%');
      tip.style.setProperty('--y', y + '%');
      tip.classList.toggle('is-below', y < 15);
      tip.textContent = 'across ' + x + ' \u00b7 down ' + y;
    });
  }

  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && open) close(true);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function () { close(false); });
})();
